import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { SaleTipFormPageRoutingModule } from './sale-tip-form-routing.module';

import { SaleTipFormPage } from './sale-tip-form.page';

import { StylistPickerModule } from '../../../components/stylist-picker/stylist-picker.module';
import { SharedModule } from '../../../shared.module';

import { MaskitoModule } from '@maskito/angular';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    StylistPickerModule,
    MaskitoModule,
    SharedModule,
    ReactiveFormsModule,
    SaleTipFormPageRoutingModule,
  ],
  declarations: [SaleTipFormPage]
})
export class SaleTipFormPageModule {}
